<template>
    <Group
        class="condition-group-wrapper"
        :value="groupData"
        :maxLevel="maxLevel"
        :conditionParams="conditionParams"
        :hiddenDelete="true"
        :validation="myValidation"
        @change="changeHandler"
        @delete="delHandler"
    />
</template>

<script>
import Group from "./Group.vue";
import { initChildNode } from "./util.js";
import Validation from "../../validation.js";

export default {
    name: "ConditionGroup",
    props: ["value", "widget", "rules", "validation"],
    components: {
        Group,
    },
    model: {
        prop: "value",
        event: "change",
    },
    data() {
        return {
            myValidation: null
        };
    },
    computed: {
        widgetProps() {
            return this.widget && this.widget.props ? this.widget.props : {};
        },
        maxLevel() {
            return this.widgetProps.maxLevel || 3;
        },
        groupData() {
            return this.value || initChildNode(this.maxLevel, 0, this.widgetProps.fixedConnector);
        },
        conditionParams() {
            return this.widgetProps.conditionParams;
        }
    },
    created() {
        this.myValidation = new Validation();
        this.validation && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    mounted() {
        if (!this.value) {
            const defVal = initChildNode(this.maxLevel, 0, this.widgetProps.fixedConnector);
            this.$emit("change", defVal);
        }
    },
    methods: {
        changeHandler(newVal) {
            this.$emit("change", newVal);
        },
        delHandler() {
            this.$emit("delete");
        }
    },
};
</script>

<style lang="less" scoped>
.condition-group-wrapper {
    min-width: 600px;
}
</style>
